import Subtitle from "../subtitle/subtitle";
import {
  AddPetButton,
  BaseCards,
  PetDetailsStyled,
} from "./pet-details.styles";
import PetDetailCard from "../pet-detail-card/pet-detail-card";
import { useContext, useEffect, useState } from "react";
import AddNewPetModal from "./add-new-pet-modal/add-new-pet-modal";
import { StepperDataContext } from "../../context/stepper-context";
import { Patient } from "../initial-details/types";
import { findPets, getAllAppointmentsTypes } from "../../../../actions";
import { AxiosError } from "axios";
import { useAppDispatch } from "../../../../store/hooks";
import { addNotification } from "../../../../store/slices/ui-slice";
import { v4 as uuid } from "uuid";
import { Pets } from "./types";
import { Typography } from "@mui/material";
import { getAge } from "../../../../utils/common-utils";

const PetDetails: React.FC = () => {
  const dispatch = useAppDispatch();
  const [pets, setPets] = useState<Pets>([]);
  const [appointmentTypes, setAppointmentTypes] = useState<
    { label: string; value: string }[]
  >([]);
  const [modalState, setModalState] = useState<{
    addNewPet: boolean;
  }>({
    addNewPet: false,
  });

  const { selectedClient } = useContext(StepperDataContext);

  const handleAddClientButton = () => {
    setModalState((state) => {
      return { ...state, addNewPet: true };
    });
  };

  const resetModalState = () => {
    setModalState((state) => {
      return { ...state, addNewPet: false };
    });
  };

  useEffect(() => {
    if (selectedClient) {
      findPets(selectedClient.integration_id)
        .then((response) => {
          const { data } = response.data;
          const pets: Pets =
            data.map((patient: Patient) => {
              return {
                id: patient.id,
                name: patient.name,
                type: patient?.breeds[0]?.label,
                gender: patient?.genders[0]?.label,
                age: getAge(patient.birthdate),
                integration_id: patient.integration_id,
              };
            }) || [];
          setPets(pets);
        })
        .catch((error) => {
          dispatch(
            addNotification({
              id: uuid(),
              type: "error",
              message: error.message,
            })
          );
        });
    }
  }, [dispatch, selectedClient]);

  useEffect(() => {
    getAllAppointmentsTypes()
      .then((response) => {
        const { data } = response.data;
        setAppointmentTypes(
          data.map((d: any) => {
            return {
              label: d.label,
              value: d.integration_id,
            };
          })
        );
      })
      .catch((error: AxiosError) => {
        dispatch(
          addNotification({
            id: uuid(),
            type: "error",
            message: error.message,
          })
        );
      });
  }, []);

  return (
    <PetDetailsStyled>
      <div className="pet-details-header">
        <Subtitle
          title={`Existing pets of ${selectedClient?.first_name} ${selectedClient?.last_name}`}
        />
        <AddPetButton
          onClick={handleAddClientButton}
          disableElevation
          disableFocusRipple
          disableRipple
          disableTouchRipple
        >
          Add new pet
        </AddPetButton>
      </div>
      <BaseCards>
        {pets.map((d, index) => (
          <PetDetailCard
            key={index}
            data={d}
            appointmentTypes={appointmentTypes}
          />
        ))}
        {pets.length === 0 && (
          <Typography className="no-records-found">
            No records found!
          </Typography>
        )}
      </BaseCards>
      <AddNewPetModal open={modalState.addNewPet} onClose={resetModalState} />
    </PetDetailsStyled>
  );
};

export default PetDetails;
